/*=====================================
    Cupoy Noteeditor Module and Directive

    Author: Gray
    CreateTime: 2019 / 03 / 07
=====================================*/
var cupoyDraftModule = angular.module('cupoy.draft', ['oc.lazyLoad']);

cupoyDraftModule.directive('ngCupoyDraft', ['$ocLazyLoad', '$timeout',
    function($ocLazyLoad, $timeout) {

        // ------------------------------
        // link
        // ------------------------------
        var link = {
            post: function(scope, element, attrs, ngModel) {
                var props = {
                    // editorid: scope.editorid,
                    noteWidth: 750,
                    placeholder: scope.placeholder,
                    isFullEditor: true,
                    disableTitle: scope.disableTitle,
                    disableMenuBar: scope.disableMenuBar,
                    disableTopBar: scope.disableTopBar,
                    disableFloatBar: scope.disableFloatBar,
                    disableLeftSidebar: scope.disableLeftSidebar,
                    isShowLogo: false,
                    isShowPreviewButton: false,
                    // noteTemplateData: [],
                    // previewButtonComponent
                    // saveButtonComponent
                    // cancelButtonComponent
                    onSave: scope.onSave,
                    onChange: scope.onChange,
                    onSaveButtonClick: scope.onSaveButtonClick,
                    onCancalButtonClick: scope.onCancalButtonClick,
                    uploadImageAttachFileCallback: scope.uploadImageAttachFileCallback,
                    uploadImageAttachURLCallback: scope.uploadImageAttachURLCallback,
                    probeURLCallback: scope.probeURLCallback,
                    // uploadTextAttachFileCallback
                    toolbarsConfig: {
                        topbar: {
                            options: [
                                'undo', 'redo', '|', 'paintformat', 'cleanformat', '|', 'blocktype', '|', 'fontsize', '|', 'bold', 
                                'italic', 'underline', 'strikethrough', 'superscript', 'subscript', 'colorpicker', '|', 
                                'textalign', 'lineheight', '|', 'list',
                            ],
                        },
                        sidebar: {
                            options: ['image', 'youtube', 'table', 'blockquote', 'divider'],
                        },
                        floatbar: {
                            options: ['highlight', 'bold', 'italic', 'link', '|', 'blocktype', 'blockquote'],   
                        },
                    },
                };

                // lazy load react, react dom and cupoy-draft.js

                var lazyjs = [
                    './js/vendors/react.production.min.js',
                    // './js/vendors/react.development.js',
                    './js/vendors/react-dom.production.min.js',
                    // './js/vendors/react-dom.development.js',
                    './cupoy-draft/cupoy-draft.js',
                ];

                var options = {
                    serie: true,
                };

                $ocLazyLoad.load(lazyjs, options).then(function() {
                    const root = $('<div ng-non-bindable></div>');
                    root.appendTo(element);

                    scope.editorRoot = root[0];

                    var appendSelector = document.body;

                    if(scope.appendSelector) {
                        appendSelector = $(scope.appendSelector);
                        appendSelector = appendSelector && appendSelector.length > 0 ? appendSelector : document.body;
                    }

                    var cupoyNoteEditorElement = React.createElement(CupoyDraft.default, props);

                    ReactDOM.render(cupoyNoteEditorElement, scope.editorRoot, function() {
                        scope.editorRef = this;

                        $timeout(function() {
                            if(scope.renderCallback) {
                                scope.renderCallback();
                            }
                        })
                    });

                    scope.$on('$destroy', function() {
                        ReactDOM.unmountComponentAtNode(scope.editorRoot);
                    });
                });
            }
        };

        // ------------------------------
        // controller
        // ------------------------------
        var controller = ['$scope', function($scope) {

            // ------------------------------
            // focusEditor
            // ------------------------------
            var focusEditor = function() {

                if($scope.editorRef && $scope.editorRef.focusEditor) {
                    $scope.editorRef.focusEditor();
                }
            }

            // ------------------------------
            // focusEditorEnd
            // ------------------------------
            var focusEditorEnd = function() {

                if($scope.editorRef && $scope.editorRef.focusEditorEnd) {
                    $scope.editorRef.focusEditorEnd();
                }
            }

            // ------------------------------
            // clearEditorContent
            // ------------------------------
            var clearEditorContent = function() {

                if($scope.editorRef && $scope.editorRef.clearEditorContent) {
                    $scope.editorRef.clearEditorContent();
                }
            }

            // ------------------------------
            // loadEditorContent
            // ------------------------------
            var loadEditorContent = function(content, title, loadCallback) {

                var _load = function() {
                    $scope.renderCallback = undefined;
                    $scope.editorRef.loadEditorContent(content, title);
                    $scope.focus();
                    loadCallback && loadCallback();
                };

                if($scope.editorRef && $scope.editorRef.loadEditorContent) {
                    _load();
                } else {
                    $scope.renderCallback = _load;
                }
            }

            // ------------------------------
            // loadHTML
            // ------------------------------
            var loadHTML = function(html, title, loadCallback) {

                var html = formatOldNoteToDraft(html);

                var _load = function() {
                    $scope.renderCallback = undefined;
                    $scope.editorRef.loadHTML(html, title);
                    $scope.focus();
                    loadCallback && loadCallback();
                };

                if($scope.editorRef && $scope.editorRef.loadHTML) {
                    _load();
                } else {
                    $scope.renderCallback = _load;
                }
            }

            // ------------------------------
            // [SCOPE] focus
            // ------------------------------
            var focus = function() {

                focusEditor();
            }

            // ------------------------------
            // [SCOPE] focusEnd
            // ------------------------------
            var focusEnd = function() {

                focusEditorEnd();
            }

            // ------------------------------
            // [SCOPE] load
            // ------------------------------
            var load = function(data) {

                if(data.content) {
                    loadEditorContent(data.content, data.title, data.loadCallback);
                } else {
                    loadHTML(data.html, data.title, data.loadCallback);
                }
            }

            // ------------------------------
            // [SCOPE] clear
            // ------------------------------
            var clear = function() {

                clearEditorContent();
            }

            /*--------------------------
                Members
            --------------------------*/
            $scope.editorRoot;
            $scope.editorRef;
            $scope.appendSelector;
            $scope.placeholder;
            $scope.disableTitle;
            $scope.disableMenuBar;
            $scope.disableTopBar;
            $scope.disableFloatBar;
            $scope.disableLeftSidebar;

            /*--------------------------
                Methods
            --------------------------*/
            $scope.focus = focus;
            $scope.focusEnd = focusEnd;
            $scope.load = load;
            $scope.clear = clear;
            $scope.renderCallback = undefined;
            $scope.onSave;
            $scope.onChange;
            $scope.onSaveButtonClick;
            $scope.onCancalButtonClick;
            $scope.uploadImageAttachFileCallback;
            $scope.uploadImageAttachURLCallback;
            $scope.probeURLCallback;

        }];
        
        /*--------------------------
            Export
        --------------------------*/
        return {
            restrict: 'E',
            link: link,
            controller: controller,
            scope: {
                // props
                appendSelector: '=', // cupoy noteeditor append的位置
                // method
                focus: '=',
                focusEnd: '=',
                load: '=',
                clear: '=',
                // Cupoy editor props
                placeholder: '=',
                disableTitle: '=',
                disableMenuBar: '=',
                disableTopBar: '=',
                disableFloatBar: '=',
                disableLeftSidebar: '=',
                onSave: '=',
                onChange: '=',
                onSaveButtonClick: '=',
                onCancalButtonClick: '=',
                uploadImageAttachFileCallback: '=',
                uploadImageAttachURLCallback: '=',
                probeURLCallback: '=',
            },
        };
    }
]);

cupoyDraftModule.directive('noteeditorModal', ['$rootScope', '$timeout', '$ngModal', '$ocLazyLoad',
    function($rootScope, $timeout, $ngModal, $ocLazyLoad) {
        var _dir = {};

        /*--------------------------
            controller
        --------------------------*/
        var controller = ['$scope', function($scope) {

            // ------------------------------
            // openNoteEditor
            // ------------------------------
            var openNoteEditor = function(modalOpenPromise) {

                if(!modalOpenPromise) {
                    return;
                }

                $timeout(function() {
                    $ngModal.openModal('note-editor-modal');
                    $scope.isOpend = true;
                    $scope.isLoadNoteError = false;
                    $scope.isLoadingNote = false;
                    $scope.newNote = undefined;

                    $scope.isLoadingNote = true;

                    modalOpenPromise().then(function(result) {
                        $scope.editorMethod.load && $scope.editorMethod.load({
                            title: result.title,
                            content: result.content,
                            html: result.html,
                            loadCallback: function() {
                                $scope.isLoadingNote = false;        
                            }
                        });
                    }, function(error) {
                        $scope.isLoadingNote = false;
                        $scope.isLoadNoteError = true;
                    });
                }, 300);
            }

            // ------------------------------
            // closeNoteEditorModal
            // ------------------------------
            var closeNoteEditorModal = function() {

                $timeout(function() {
                    $ngModal.closeModal('note-editor-modal');
                    $scope.isOpend = false;
                    window.onbeforeunload = undefined;
                });
            };

            // ------------------------------
            // [SCOPE] onChange
            // ------------------------------
            var onChange = function(payload) {

                if(!payload) {
                    payload = {};
                }

                $scope.newNote = {
                    content: payload.rawData,
                    html: payload.html,
                    title: payload.title,
                };

                if(!$scope.isSaveLastNoteInfo) {
                    $scope.lastSavedNote = $scope.newNote;
                    $scope.isSaveLastNoteInfo = true;
                }

                if(JSON.stringify($scope.newNote) !== JSON.stringify($scope.lastSavedNote)) {
                    $scope.changeUnsaved = true;
                }
            }

            // ------------------------------
            // [SCOPE] onSave
            // ------------------------------
            var onSave = function(payload) {
                
                $scope.isSaving = true;
                $scope.isSaveError = false;
                $scope.error = undefined;

                var successCallback = function() {
                    $scope.isSaving = false;
                    $scope.isSaveLastNoteInfo = false;
                    $scope.changeUnsaved = false;
                }

                var errorCallback = function(error) {
                    $scope.isSaveError = true;
                    $scope.error = error;
                }

                $scope.saveNoteCallback && $scope.saveNoteCallback(payload, successCallback, errorCallback);
            }

            // ------------------------------
            // [SCOPE] onSaveButtonClick
            // ------------------------------
            var onSaveButtonClick = function() {
                
                closeNoteEditorModal();
            }
            
            // ------------------------------
            // [SCOPE] onCancalButtonClick
            // ------------------------------
            var onCancalButtonClick = function() {

                $scope.cancelNoteCallback && $scope.cancelNoteCallback();

                closeNoteEditorModal();
            }

            // ------------------------------
            // reset
            // ------------------------------
            var reset = function() {

                $scope.lastSavedNote.title = undefined;
                $scope.lastSavedNote.content = undefined;
                $scope.lastSavedNote.html = undefined;

                $scope.isSaveLastNoteInfo = false;
                $scope.isSaving = false;
                $scope.isSaveError = false;
                $scope.error = undefined;
            }

            /*==========================
                Events
            ==========================*/
            // 防止使用者忽然關閉視窗或是離開本站時阻擋事件
            window.onbeforeunload = function() {

                if(!$scope.isOpend) {
                    return;
                }

                if($scope.changeUnsaved) {
                    return '您的修改並未儲存，確定要離開嗎？';
                }
            }

            $scope.$on('CLOSE_NOTE_EDITOR_MODAL', function(event, data) {

                closeNoteEditorModal();
            });

            $scope.$on('OPEN_NOTE_EDITOR_MODAL', function(event,data) {

                if(!data) {
                    return;
                }

                reset();

                $scope.saveNoteCallback = data.saveNoteCallback;
                $scope.cancelNoteCallback = data.cancelNoteCallback;
                // editor props
                $scope.placeholder = data.placeholder || "在這裡開始輸入內容...";
                $scope.disableTitle = data.disableTitle || false;
                $scope.uploadImageAttachFileCallback = data.uploadImageAttachFileCallback;
                $scope.uploadImageAttachURLCallback = data.uploadImageAttachURLCallback;
                $scope.probeURLCallback = data.probeURLCallback;

                openNoteEditor(data.modalOpenPromise);
            });

            /*==========================
                Members
            ==========================*/
            $scope.isOpend = false;
            $scope.changeUnsaved = false;
            $scope.isSaving = false;
            $scope.lastSavedNote = {
                title: undefined,
                content: undefined,
                html: undefined,
            };

            // noteeditor public method
            $scope.editorMethod = {
                focus: undefined,
                focusEnd: undefined,
                load: undefined,
                clear: undefined,
            }

            // $scope.appendSelector = '#note-editor-modal .md-wrapper';

            // noteeditor props variable
            $scope.placeholder;
            $scope.disableTitle;

            /*==========================
                Methods
            ==========================*/
            $scope.saveNoteCallback = undefined;
            $scope.cancelNoteCallback = undefined;
            // noteeditor props method
            $scope.onChange = onChange;
            $scope.onSave = onSave;
            $scope.onSaveButtonClick = onSaveButtonClick;
            $scope.onCancalButtonClick = onCancalButtonClick;
            $scope.uploadImageAttachFileCallback;
            $scope.uploadImageAttachURLCallback;
            $scope.probeURLCallback;
        }];

        _dir.restrict = 'E';
        _dir.scope = true;
        _dir.templateUrl = 'partials/modal/noteeditor_modal.html';
        _dir.controller = controller;

        return _dir;
    }
]);

cupoyDraftModule.directive('previewCupoyNoteEditor', ['$ocLazyLoad', function($ocLazyLoad) {

    var link = function(scope, element, attrs) {

        var notewidth = attrs.width;
        notewidth = isNaN(notewidth) ? undefined : Number(notewidth);

        if(notewidth) {
            scope.noteStyle = {
                width: notewidth + 'px',
            };
        }

        var lazyjs = [
            './cupoy-draft/CupoyNoteHtmlParser.js',
            './cupoy-draft/cupoydraft.css',
        ];

        var options = {
            serie: true,
        };

        $ocLazyLoad.load(lazyjs, options).then(function() {

            var clearWatch = scope.$watch('html', function(newValue, oldValue) {
                
                if(newValue) {
                    var parser = new CupoyNoteHtmlParser(newValue);
                    var result = parser.getResult().outerHTML;

                    scope.result = result;
                    // clearWatch();
                }
            });
        });
    }

    /*--------------------------
            Export
        --------------------------*/
        return {
            restrict: 'E',
            link: link,
            replace: "true",
            template: '<div class="cupoydraft-content-style" ng-bind-html="result" ng-style="noteStyle"></div>',
            scope: {
                html: '=',
                width: '&'
            },
        };
}])